
























import {Component, Vue} from 'vue-property-decorator'
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";

@Component({
    components: {
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
    },
})
export default class ErrorPreviewDialog extends Vue {
}
